import React from 'react';

import ModalContainer from '@/components/modals/ModalContainer';
import CommonImage from '@/components/CommonImage';
import { onGetLocalFromUtc } from '@/utils/Util';

import { useGetHistoryByProductIdQuery } from '../api/costingAgentApi';

import { LoadingState } from './LoadingState';

const VersionSidebar = ({ productId, selectedHistoryId, onHistorySelect, onClose }) => {
	const { data: historyData, isLoading } = useGetHistoryByProductIdQuery(productId);

	const formatPrice = (price) => {
		if (!price) return '$0';
		return `$${parseFloat(price).toFixed(2)}`;
	};

	const handleHistoryItemClick = (historyId) => {
		onHistorySelect(historyId);
		onClose();
	};

	return (
		<ModalContainer onCloseModal={onClose} className="modal-right">
			<div className="costing-sidebar-header border-bottom">
				<div className="d-flex justify-content-between px-4 py-3">
					<p className="semibold-14 reqular-14">Costing History</p>
					<CommonImage src="/icons/close.svg" className="cursor-pointer" onClick={onClose} />
				</div>
			</div>

			<div className="costing-sidebar-body px-4">
				{isLoading ? (
					<LoadingState isLoading={true} />
				) : historyData?.payload && historyData.payload.length > 0 ? (
					historyData.payload.map((item, index) => {
						const isActive = selectedHistoryId === item.id;
						const reverseVersionNumber = historyData.payload.length - index;
						return (
							<div
								key={item.id}
								className={`costing-history-item border p-3 pt-2 mt-3 cursor-pointer ${
									isActive ? 'active' : ''
								}`}
								onClick={() => handleHistoryItemClick(item.id)}
								style={{
									backgroundColor: isActive ? '#eeebf6' : 'transparent',
									borderColor: isActive ? '#452d8f' : undefined,
									borderWidth: isActive ? '2px' : '1px'
								}}
							>
								<div className="d-flex justify-content-between">
									<div>
										<p className="semibold-14 reqular-14 mb-2">
											Version {reverseVersionNumber}
										</p>
										<p className="regular-12 gray_dark_03 mb-1">
											<span>
												<CommonImage
													src="/images/icons/calendar.svg"
													width={14}
													height={14}
												/>
											</span>{' '}
											{onGetLocalFromUtc(item?.createdAt, 'MMM DD, YYYY')} -{' '}
											{onGetLocalFromUtc(item?.createdAt, 'h:mm a')}
										</p>
										<p className="regular-12 gray_dark_02 d-flex align-items-center gap-1">
											<span>
												<CommonImage
													src="/images/pro_pic_default.svg"
													width={14}
													height={14}
												/>
											</span>{' '}
											{item.createdBy?.name || 'Unknown'}
										</p>
									</div>
									<div>
										<p className="semibold-14 reqular-14">FOB</p>
										<p className="regular-12 gray_dark_02 pt-1">
											{formatPrice(item.price)}
										</p>
									</div>
								</div>
							</div>
						);
					})
				) : (
					<div className="p-4 text-center">
						<p className="regular-12 gray_dark_02">No history available</p>
					</div>
				)}
			</div>
		</ModalContainer>
	);
};

export default VersionSidebar;
